{
  "name": "esd-ngponline-angular-client",
  "version": "v236",
  "appId": "A1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.3",
    "@angular/cdk": "^19.2.6",
    "@angular/common": "^19.2.3",
    "@angular/compiler": "^19.2.3",
    "@angular/core": "^19.2.3",
    "@angular/forms": "^19.2.3",
    "@angular/language-service": "^19.2.3",
    "@angular/localize": "^19.2.3",
    "@angular/material": "^19.2.6",
    "@angular/material-moment-adapter": "^19.2.6",
    "@angular/platform-browser": "^19.2.3",
    "@angular/platform-browser-dynamic": "^19.2.3",
    "@angular/router": "^19.2.3",
    "@bluehalo/ngx-leaflet": "^19.0.0",
    "@esders/analytics": "^19.2.1",
    "@esders/authentificate": "^19.2.0",
    "@esders/connect-api": "^357.0.0",
    "@esders/gui": "^19.2.0",
    "@esders/shop-api": "^121.0.1",
    "@esders/theme": "^19.1.2",
    "@esders/utilities": "^19.1.0",
    "@ngx-translate/core": "^16.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@types/d3-scale": "^4.0.3",
    "@types/d3-selection": "^3.0.5",
    "@types/d3-shape": "^3.1.1",
    "@types/leaflet": "^1.9.0",
    "@types/xmljs": "^0.3.2",
    "angular": "^1.8.3",
    "angular-auth-oidc-client": "19.0.0",
    "leaflet": "^1.9.3",
    "moment": "^2.29.4",
    "ngx-cookie-service": "^19.1.2",
    "ngx-image-cropper": "^8.0.0",
    "ng2-charts": "7.0.0",
    "chart.js": "^4.4.8",
    "project": "^0.1.6",
    "rxjs": "^7.8.0",
    "stream-browserify": "^3.0.0",
    "timers-browserify": "^2.0.12",
    "tslib": "^2.4.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.4",
    "@angular/cli": "^19.2.4",
    "@angular/compiler-cli": "^19.2.3",
    "@types/jasmine": "^4.3.1",
    "@types/jasminewd2": "^2.0.10",
    "@types/node": "^18.11.18",
    "@types/xml2js": "^0.4.11",
    "file-loader": "^6.2.0",
    "image-webpack-loader": "^8.1.0",
    "jasmine-core": "~4.5.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.1",
    "karma-chrome-launcher": "~3.1.1",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.0.0",
    "mini-css-extract-plugin": "^2.7.2",
    "protractor": "~7.0.0",
    "sass": "^1.57.1",
    "trim-newlines": "^4.0.2",
    "ts-node": "~10.9.1",
    "tslint": "^6.1.3",
    "typescript": "^5.5.4",
    "url-loader": "^4.1.1"
  }
}
